import React from 'react';
import { useTranslation } from 'react-i18next';

import Cta from 'component/Layout/Cta';
import { CtaTheme, CtaType } from 'component/Layout/Cta/types';

import { useSetAtom } from 'jotai';

import { QaIdentifier } from 'hooks/useQa';

import {
    fallbackNoteVisibility,
    refreshNoteVisibility,
} from 'data/Atom/Component';

import RefreshNote from '../RefreshNote';

import styles from './SubmitContainer.module.scss';

interface SubmitContainerProps {
    onSubmit?: () => void;
    customClass?: string;
    withRefreshNote?: boolean;
}

const SubmitContainer = ({
    onSubmit,
    customClass = '',
    withRefreshNote = true,
}: SubmitContainerProps) => {
    const { t } = useTranslation();

    const setRefreshNoteVisibility = useSetAtom(refreshNoteVisibility);
    const setIsFallbackNoteVisible = useSetAtom(fallbackNoteVisibility);

    return (
        <div className={styles.SubmitContainer}>
            <Cta
                type={CtaType.BUTTON}
                theme={CtaTheme.PRIMARY}
                onClick={() => {
                    setRefreshNoteVisibility(false);
                    setIsFallbackNoteVisible(false);
                    onSubmit?.();
                }}
                qaId={QaIdentifier.Search_Form_Submit_CTA}
                customClassList={{
                    Cta: customClass,
                }}
            >
                {t('TRANS-search-for')}
            </Cta>
            <RefreshNote withRefreshNote={withRefreshNote}>
                <span>{t('TRANS-refresh-results')}</span>
            </RefreshNote>
        </div>
    );
};

export default SubmitContainer;
